export const DEFAULT_WAVE_COLOR = '#30AEF2';
export const NO_VIDEO_GREY_BG = `#eef0f6`;
export const WAVE_BLACK_COLOR = '#292A2B';
export const DEFAULT_STUDIO_BG = '#adcbe3';
